import { TenantConfig } from './types';

/**
 * Configuración para neureka.es (sitio principal - adultos)
 * Tema: Morado/Amarillo, elegante, profesional
 * Audiencia: Adultos, profesionales, pacientes
 */
export const defaultConfig: TenantConfig = {
  slug: 'default',
  name: 'Neureka',
  domain: 'neureka.es',

  theme: {
    colors: {
      primary: '#8B5CF6',           // Morado vibrante
      secondary: '#7C3AED',         // Morado oscuro
      accent: '#FCD34D',            // Amarillo Neureka
      background: '#0F172A',        // Azul oscuro de fondo
      gradients: {
        main: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        header: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)',
        card: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(124, 58, 237, 0.05) 100%)',
      },
    },

    fonts: {
      primary: {
        family: 'Poppins',
        weights: [300, 400, 500, 600, 700],
        googleFont: true,
      },
      body: {
        family: 'Inter',
        weights: [300, 400, 500, 600],
        googleFont: true,
      },
      decorative: {
        family: 'Montserrat',
        weights: [600, 700, 800],
        googleFont: true,
      },
    },

    spacing: {
      buttonPadding: '0.75rem 1.5rem',
      cardBorderRadius: '16px',
      headerHeight: '64px',
      containerPadding: '1rem',
    },

    effects: {
      glassmorphism: true,
      blur: '10px',
      animations: 'elegant',
      shadows: 'medium',
    },
  },

  features: {
    enabledGames: [
      'kakurasu',
      'hitori',
      'lightup',
      'futoshiki',
      'hashi',
      'binary',
      'calcudoku',
      'castles',
      'tents',
      'bombillas',
      'convergencia',
      'vecinos',
      'thermometers',
      'bricks',
      'flechas',
      'fillomino',
      'unruly',
    ],
    showAdultGames: true,
    timeControl: false,
    parentalControl: false,
    multiProfile: false,
    sessionTypes: ['presencial', 'remota'],
    achievements: 'default',
    showProfessionalFeatures: true,
    showAdminFeatures: true,
  },

  content: {
    logoText: 'NEUREKA',
    logoIcon: '🧠',
    tagline: 'Despierta tu mente',
    homeHero: {
      title: 'Entrena tu cerebro con puzzles de lógica',
      subtitle: 'Más de 17 juegos diseñados para mejorar tus habilidades cognitivas',
    },
    footer: {
      text: '© 2024 Neureka - Estimulación Cognitiva',
      links: [
        { label: 'Términos', url: '/terminos' },
        { label: 'Privacidad', url: '/privacidad' },
        { label: 'Contacto', url: '/contacto' },
      ],
    },
  },

  routes: {
    home: '/',
    games: '/juegos',
    profile: '/perfil',
    login: '/login',
  },
};
